<article class="content-page section-inset-y" *ngIf="page$ | async as page">
  <header class="mb-5 container container-size-xxs">
    <h1 class="">{{ page.title }}</h1>
    <figure class="mt-3 content-page__figure shadow--right" *ngIf="page.image.url">
      <img class="d-block" [src]="page.image.url | resize : 1000" [alt]="page.image.alt" />
    </figure>
    <div class="section-header__background">
      <fstr-icon class="section-header__background__icon aspect-icon-icon-m" anchor="icon-m"></fstr-icon>
    </div>
  </header>
  <main class="content-page__main">
    <div class="container container-size-xxs">
      <div class="content-page__intro mb-4 lead" *ngIf="page.intro">{{ page.intro }}</div>
      <div class="content-page__text markdown-content" [innerHTML]="page.text | resizeHtmlImages | safe"></div>
    </div>
  </main>
</article>
